import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';

/**
 * 終了処理メソッド
 */
export async function disposeApi(self) {
  try {
    self.isLoading = true;
    const token = session.getToken();
    // 以下、エラーが発生してもエラー処理も行わないためエラーハンドリングは実行しない
    await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'dispose'
      },
    );
  }
  finally {
    self.isLoading = false;
  }
}